<template>
<div>
    <ul class="rec_list24">
        <li v-for="(item) in dataList" :key="item.id" @click="newsClick(item)">
            <a :href="item.link" target="_blank"><span v-if="showTag">{{item.field_one}}</span>{{item.title}}</a>
        </li>
    </ul>
</div>
</template>

<script>
// 神策埋点
import { newsClick } from '@/utils/buriedPoint.js'
export default {
    name: "baseList",
    props:["dataList","showTag"],
    methods: {
        newsClick(item) {
            newsClick(item.id,item.title)
        }
    }
}
</script>

<style scoped lang="scss">
@import url(../../../assets/css/list.scss);
ul {
    li{
        width: 240px;
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
    }
}
</style>